import React, { Fragment, useState, useContext, memo } from "react";
import SystemContext from "../../SystemContext";
import {useQueryClient} from "react-query";
import { makeStyles } from "@material-ui/core/styles";
import {Tooltip, Icon, Divider, withStyles, Box, IconButton, Badge, useTheme} from "@material-ui/core";
import __ from "lodash";
import moment from "moment";
import TripToolTipStyles from "./TripToolTipStyles";
import { useAirportNotams, useAirports } from "../../services/airports";
import { useAircraft } from "../../services/aircraft";
import { useNotes } from "../../services/notes";
import IconButtonMenu from "../IconButtonMenu";
import {buildTripMenu} from "./ContextMenus";
import Icons, {
  AirCargoIcon,
  ChecklistIcon,
  FoodIcon,
  NotesIcon,
  PilotIcon,
  PinIcon,
  PinOffIcon,
  WorldCheckIcon
} from "../../icons";
import { Stack } from "@mui/material";
import HandshakeIcon from "../../icons/HandshakeIcon";

import ExternalScreen from "./TripPopupScreens/ExternalScreen";
import MapScreen from "./TripPopupScreens/MapScreen";
import CrewScreen from "./TripPopupScreens/CrewScreen";
import AirportSlotIcon from "../../icons/AirportSlotIcon";
import PermitsScreen from "./TripPopupScreens/PermitsScreen";
import CargoScreen from "./TripPopupScreens/CargoScreen";
import ChecklistScreen from "./TripPopupScreens/ChecklistScreen";
import ServicesScreen from "./TripPopupScreens/ServicesScreen";
import FuelScreen from "./TripPopupScreens/FuelScreen";
import CateringScreen from "./TripPopupScreens/CateringScreen";
import NotesScreen from "./TripPopupScreens/NotesScreen";
import SlotsScreen from "./TripPopupScreens/SlotsScreen";
import MonitorScreen from "./TripPopupScreens/MonitorScreen";

import { ReactComponent as ChecklistStatusIndicator } from '../../assets/ChecklistStatusIndicator.svg';
import { useTripLegIndicators, useTripLegSpecialLoads } from "../../services/trips";
import { useSchedulingScratchPads } from "../../services/flightPlanning";
import LightTooltip from "../LightTooltip";
import useAirportCurfewCheck from "../../services/airports/useAirportCurfewCheck";
import { Dvr } from "@material-ui/icons";

const tabWidth = 42;

const emptySlr = {
  slr: {count: 0, records: []},
  dgr: {count: 0, records: []},
  temp: {count: 0, records: []},
  avi: {count: 0, records: []},
}

const TabBadge = withStyles(theme => ({
  badge: {
    height: 15,
    minWidth: 15,
    borderRadius: 7
  },
  anchorOriginTopLeftRectangle: {
    transform: "scale(1) translate(-30%, 5%)"
  },
}))(Badge);

const TabBar = (props) => {

  const tripData = props.tripData;
  const editing = props.editing;
  const canChange = props.canChange;
  const canViewDetails = props.canViewDetails;
  const indicators = props.indicators||{};
  const [selectedTab, setSelectedTab] = useState(props.selectedScreen || "map");
  const queryClient = useQueryClient();

  const handleTabSelection = (tab) => {
    setSelectedTab(tab);
    if (props.callback) {
      props.callback(tab);
    }
  }

  const notesKeys = [tripData.uuid, encodeURIComponent('TRIP_LEG:FLIGHT%')];
  const notes = useNotes({queryClient, extraKeys: notesKeys});
  const notesCount = notes && Array.isArray(notes.data)?notes.data.length:0;

  const specialLoads = props.specialLoads;

  let cargoTags = [];

  if (specialLoads) {
    const {slr, dgr, temp, avi} = specialLoads;

    if (slr && slr.count > 0) {
      cargoTags.push(<Icons style={{fontSize: 14, padding: 1, marginTop: -4}} color="secondary">SlrIcon</Icons>)
    }
    if (dgr && dgr.count > 0) {
      cargoTags.push(<Icons style={{fontSize: 14, padding: 1, marginTop: -4}} color="secondary">warning_amber</Icons>)
    }
    if (temp && temp.count > 0) {
      cargoTags.push(<Icons style={{fontSize: 14, padding: 1, marginTop: -4}} color="secondary">thermostat</Icons>)
    }
    if (avi && avi.count > 0) {
      cargoTags.push(<Icons style={{fontSize: 14, padding: 1, marginTop: -4}} color="secondary">AviIcon</Icons>)
    }
  }

  const TabBarBox = withStyles(theme => ({
    root: {
      position: "relative",
      padding: 0,
      paddingTop: 12,
      paddingBottom: 6,
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: 'transparent',
        color: theme.palette.primary.light
      },
      '&.Mui-selected:hover': {
        backgroundColor: 'transparent'
      },
      '&.tabSelected': {
        color: theme.palette.primary.main
      }
    },
  }))(Box);

  const StatusIndicator = (props) => {
    const {color} = props;
    if (color === "none") {
      return null;
    }
    return (
      <div style={{position: "absolute", top: 3, right: -8}}>
        <ChecklistStatusIndicator style={{fill: `${color||'#ff0000'}`, stroke: "#777777", width: 12, height: 12 }}/>
      </div>
    )
  }

  const Tags = (props) => {
    const {tags} = props;
    if (!tags || !Array.isArray(tags) || tags.length === 0) {
      return null;
    }
    return (
      <div style={{position: "absolute", bottom: -4, left: -8, width: 66, height: 14, backgroundColor: "rgba(0,0,0,0.07)"}}>
        <div style={{position: "absolute", top: 5, width: "100%", textAlign:"center"}}>
          <Stack
            direction="row"
            spacing={0}
            justifyContent="space-around"
            alignContent="center"
          >
            {props.tags.map(tag => (
              <div>{tag}</div>
            ))}
          </Stack>
        </div>
      </div>
    )
  }

  const TabBarIconButton = (props) => {
    // const indicators = tripData?.indicators||{};
    // let status = "NOT REQUIRED";
    const {selectedTab, type, count} = props;
    const indicator = indicators[type]||{color: 'none', status: 'NOT REQUIRED'};
    const {color, status} = indicator;

    if (count) {
      return (
      <TabBadge anchorOrigin={{horizontal:'left',vertical:'top'}} badgeContent={`${count}`} color={"primary"}>
        <TabBarBox
          className={selectedTab===type?"tabSelected":""}
          onClick={()=>{handleTabSelection(type)}}
        >
          <div style={{...props.iconStyle, width: tabWidth, textAlign: "center"}}>
            {props.children}
          </div>
          <StatusIndicator color={color}/>
          <Tags tags={props.tags}/>
        </TabBarBox>
      </TabBadge>
      )
    }
    return (
      <TabBarBox
        className={selectedTab===type?"tabSelected":""}
        onClick={()=>{handleTabSelection(type)}}
      >
        <div style={{...props.iconStyle, width: tabWidth, textAlign: "center"}}>
          {props.children}
        </div>
        <StatusIndicator color={color}/>
        <Tags tags={props.tags}/>
      </TabBarBox>
    )
  }

  if (!canViewDetails) return null;

  if (editing) {
    return null;
  }

  //TODO: Need to get icon screens working for scheduled trips as needed
  if (tripData.type === "SCHEDULED") {
    return null;
  }

  if (tripData.type === "SCHEDULED") {
    return (
      <div>
        <Stack
          direction="row"
          spacing={0}
          justifyContent="space-around"
          alignContent="center"
          divider={<Divider orientation="vertical" flexItem />}
        >
          <item><TabBarIconButton type="map" selectedTab={selectedTab}><Icon fontSize="large">location_on</Icon></TabBarIconButton></item>
          <item><TabBarIconButton type="services" selectedTab={selectedTab}><HandshakeIcon fontSize="large"/></TabBarIconButton></item>
          <item><TabBarIconButton type="cargo" selectedTab={selectedTab} iconStyle={{marginTop: -3}}><AirCargoIcon fontSize="large"/></TabBarIconButton></item>
          <item><TabBarIconButton type="slots" selectedTab={selectedTab}><AirportSlotIcon fontSize="large"/></TabBarIconButton></item>
          <item><TabBarIconButton type="notes" selectedTab={selectedTab} count={notesCount}><Icon fontSize="large">description</Icon></TabBarIconButton></item>
        </Stack>
      </div>
    )
  }

  if (canViewDetails === "ULD") {
    return (
      <div style={{marginTop: 70}}>
        <Stack
          direction="row"
          spacing={0}
          justifyContent="space-around"
          alignContent="center"
          divider={<Divider orientation="vertical" flexItem />}
        >
          <item><TabBarIconButton type="map" selectedTab={selectedTab}><Icon fontSize="large">location_on</Icon></TabBarIconButton></item>
          <item><TabBarIconButton type="services" selectedTab={selectedTab}><HandshakeIcon fontSize="large"/></TabBarIconButton></item>
          <item><TabBarIconButton type="cargo" selectedTab={selectedTab} iconStyle={{marginTop: -3}}><AirCargoIcon fontSize="large"/></TabBarIconButton></item>
          {/* <item><TabBarIconButton type="notes" selectedTab={selectedTab} count={notesCount}><Icon fontSize="large">description</Icon></TabBarIconButton></item> */}
        </Stack>
      </div>
    )
  }

  return (
    <div>
      <Stack
        direction="row"
        spacing={0}
        justifyContent="space-around"
        alignContent="center"
        divider={<Divider orientation="vertical" flexItem />}
      >
        <item><TabBarIconButton type="map" selectedTab={selectedTab}><Icon fontSize="large">location_on</Icon></TabBarIconButton></item>
        <item><TabBarIconButton type="permits" selectedTab={selectedTab}><WorldCheckIcon fontSize="large"/></TabBarIconButton></item>
        <item><TabBarIconButton type="slots" selectedTab={selectedTab}><AirportSlotIcon fontSize="large"/></TabBarIconButton></item>
        <item><TabBarIconButton type="cargo" selectedTab={selectedTab} tags={cargoTags} iconStyle={{marginTop: -3}}><AirCargoIcon fontSize="large"/></TabBarIconButton></item>
        <item><TabBarIconButton type="checklist" selectedTab={selectedTab}><ChecklistIcon fontSize="large"/></TabBarIconButton></item>
        <item><TabBarIconButton type="monitor" selectedTab={selectedTab}><Dvr fontSize="large"/></TabBarIconButton></item>
      </Stack>
      <div style={{backgroundColor: "#d0d0d0", width: "calc(100% + 8px)", height: 1, marginLeft: -4}}></div>
      <Stack
        direction="row"
        spacing={0}
        justifyContent="space-around"
        alignContent="center"
        divider={<Divider orientation="vertical" flexItem />}
      >
        <item><TabBarIconButton type="crew" selectedTab={selectedTab}><PilotIcon fontSize="large"/></TabBarIconButton></item>
        <item><TabBarIconButton type="services" selectedTab={selectedTab}><HandshakeIcon fontSize="large"/></TabBarIconButton></item>
        <item><TabBarIconButton type="catering" selectedTab={selectedTab}><FoodIcon fontSize="large"/></TabBarIconButton></item>
        <item><TabBarIconButton type="fuel" selectedTab={selectedTab}><Icon fontSize="large">local_gas_station</Icon></TabBarIconButton></item>
        <item><TabBarIconButton type="servicechecklist" selectedTab={selectedTab}><Icon fontSize="large">playlist_add_check</Icon></TabBarIconButton></item>
        <item><TabBarIconButton type="notes" selectedTab={selectedTab} count={notesCount}><NotesIcon fontSize="large"/></TabBarIconButton></item>
      </Stack>
  </div>
)
}

const AirportData = (props) => {
  const queryClient = useQueryClient();

  const airport = useAirports({queryClient, extraKeys:[props.airportCode], useCache: true});

  return (<div style={props.style}>{airport.data?airport.data[0][props.field]:props.airportCode}</div>)
}

const ContextMenu = (props) => {
  const theme = useTheme();
  const {tripData, editing, canChange, canViewDetails} = props;

  const queryClient = useQueryClient();
  const aircrafts = useAircraft({queryClient, extraKeys:["active"], useCache: true});
  const userScratchPads = useSchedulingScratchPads({queryClient, extraKeys:[]});

  const menuItems = buildTripMenu(tripData, aircrafts, editing, canChange, userScratchPads, canViewDetails);

  if (!menuItems || !Array.isArray(menuItems) || menuItems.length < 1) return null;

  return (
    <IconButtonMenu
      style={{ color: theme.palette.primary.main }}
      hidden={false}
      size={"small"}
      offset={-1}
      tooltip={"Actions"}
      icon={(<Icon>menu</Icon>)}
      menuItems={menuItems}
      zIndex={1500}
      callback={props.callback}
      callbackParams={{tripData}}
    />
  )
}

const TripTooltip = (props) => {
  const queryClient = useQueryClient();

  const { tripData, editing, canChange, colours, canViewDetails, style } = props;
  const toolTipPinned = props.toolTipPinned;
  const pinned = (toolTipPinned.current && toolTipPinned.current?.open && toolTipPinned.current?.uuid === tripData.uuid) || false;
  const screen = (toolTipPinned.current && toolTipPinned.current.selectedScreen) ? toolTipPinned.current.selectedScreen : "map";
  const classes = makeStyles(TripToolTipStyles)();

  const [opened, setOpened] = useState(pinned);
  const [canClose, setCanClose] = useState(!pinned);

  const SystemData = useContext(SystemContext);
  const eventBus = SystemData.eventBus;

  const extraKeys = [tripData.uuid];
  const tripLegIndicators = useTripLegIndicators({queryClient, extraKeys});

  const specialLoads = useTripLegSpecialLoads({queryClient, extraKeys: [tripData.uuid]});

  const handleClose = () => {
    if (canClose) {
      setOpened(false);
      if (!props.showAsSidePanel) eventBus.trigger("RouteView.popupPause", false);
      props.onClose();
    }
  }

  const TripScreen = memo ((props) => {
    const {editing, canChange, tripData, eventBus, colours} = props;
    const classes = makeStyles(TripToolTipStyles)();
    const [selectedScreen, setSelectedScreen] = useState(screen);
    if (!tripData) return null;

    const togglePreventClose = () => {
      const wasPinned = !canClose;
      toolTipPinned.current = {...toolTipPinned.current, open: canClose};
      setCanClose(wasPinned);
    }

    const tabChanged = (tabNo) => {
      setSelectedScreen(tabNo);
      toolTipPinned.current = {...toolTipPinned.current, selectedScreen: tabNo};
    }

    const handleMenuAction = (params) => {
      const {selectedAction, tripData, extraData} = params;
      if (__.isString(selectedAction)) {
        eventBus.trigger(`RouteView.TimeWindow.TripAction.${selectedAction}`, {tripData, extraData});
      }
    }

    const FlightBlock = (props) => {
      const withinCurfew = props.withinCurfew;
      const diverted = props.diverted;
      const {noteText, noteData} = props.diversionDetails||{};
      const {destinationAirportCode, divertedToAirport} = noteData||{};
      let colorProps = withinCurfew?{backgroundColor: "rgba(255,0,0,1)"}:diverted?{backgroundColor: "rgba(118,71,152,1)"}:{}
      return (
        <div style={{width: 120, display: "inline-block", border: "2px solid #ffffff", textAlign: "center", ...colorProps}}>
          <div style={{fontSize: 20, fontWeight: "bold", padding: 8}}>{diverted?<span style={{textDecoration:"line-through", paddingRight: 5}}>{destinationAirportCode}</span>:''}{props.airportCode}</div>
          <div style={{fontSize: 18, fontWeight: "bold", padding: 6}}><AirportData airportCode={props.airportCode} field='icaoCode'/></div>
          <div style={{fontSize: 14, fontWeight: "bold", padding: 6}}>{moment.utc(props.flightTime).format('DD MMM HH:mm')}</div>
        </div>
      )
    }


    const CurfewToolTip = (props) => {
      const {airportCode, flightTime, flightDirection} = props;
      const airportCurfews = useAirportCurfewCheck({queryClient, extraKeys:[airportCode, flightDirection, flightTime], useCache: true})

      if (!airportCurfews) return (<></>);
      const flightWithinCurfew = airportCurfews && Array.isArray(airportCurfews.data) && airportCurfews.data.length > 0;
      if (flightWithinCurfew) {
        return (
          <LightTooltip title={
            <div>
              {airportCurfews.data.map((airportCurfew) => {
                let restrictionType = "";
                switch (airportCurfew.notamCode) {
                  case "AIRPORT":
                  case "CURFEW":
                    restrictionType = "Airport Curfew Operating";
                    break;
                  case 'RWY':
                    restrictionType = "Notam runway restrictions in effect";
                    break;
                  case 'TWY':
                    restrictionType = "Notam taxiway restrictions in effect";
                    break;
                  default:
                    restrictionType = "Notam restrictions in effect"
                }
                const fromTime = moment.utc(airportCurfew.fromTime).format('HH:mm');
                const toTime = moment.utc(airportCurfew.toTime).format('HH:mm');
                return (
                  <div>{restrictionType} between {fromTime} and {toTime} ({airportCurfew.notamDetails})</div>
                )
              })}
            </div>
          }>
            <div style={{display: "inline-block"}}>
              <FlightBlock airportCode={airportCode} flightTime={flightTime} withinCurfew={flightWithinCurfew} />
            </div>
          </LightTooltip>
        )
      } else {
        return (
          <FlightBlock airportCode={airportCode} flightTime={flightTime} withinCurfew={flightWithinCurfew} />
        )
      }
    }

    const FlightBlockWithCurfewCheck = (props) => {
      const {airportCode, flightTime, flightDirection, checkCurfew, diverted, diversionDetails} = props;

      if (!checkCurfew) {
        return (
          <FlightBlock airportCode={airportCode} flightTime={flightTime} withinCurfew={false} diverted={diverted} diversionDetails={diversionDetails}/>
        )
      }

      return (
        <CurfewToolTip airportCode={airportCode} flightTime={flightTime} flightDirection={flightDirection} diverted={diverted} diversionDetails={diversionDetails}/>
      )
    }

    if (!specialLoads || !tripLegIndicators) return (<></>);
    const aircraftTailNumber = tripData.aircraftReg.split('|').length > 1 ? tripData.aircraftReg.split('|')[1] : tripData.aircraftReg;

    return (
      <div style={style}>
          <div style={{position: "absolute"}}>
            <ContextMenu
              callback={handleMenuAction}
              tripData={tripData}
              editing={editing}
              canChange={canChange}
              canViewDetails={canViewDetails}
            />
          </div>
          <div style={{position: "absolute", top: 0, right: 0}}>
            {props.showAsSidePanel?<></>:
              <IconButton onClick={()=>togglePreventClose()} style={{padding: 6, fontSize: 24, color: "#ffffff"}}>
                {canClose?<PinOffIcon fontSize="inherit"/>:<PinIcon fontSize="inherit"/>}
              </IconButton>
            }
          </div>
          <div style={{ textAlign: "center", fontSize: 24, fontWeight: "bold", padding: 8}}>{tripData.airlineCode}{tripData.flightNo} ({tripData.tripNo})
          </div>
          <div style={{ padding: 10, textAlign: "center"}}>
            <FlightBlockWithCurfewCheck airportCode={tripData.originAirportCode} flightTime={tripData.scheduledDepartureTimeUtc} flightDirection="OUT" checkCurfew={tripData.withinCurfew} diverted={false} diversionDetails={{}}/>
            <div style={{verticalAlign: "top", display: "inline-block"}}>
            <div style={{fontSize:10, marginTop: 15}}>{aircraftTailNumber}</div>
              <div style={{transform: "rotate(90deg)", padding: "5px 15px"}}><Icon>flight</Icon></div>
            </div>
            <FlightBlockWithCurfewCheck airportCode={tripData.destinationAirportCode} flightTime={tripData.scheduledArrivalTimeUtc} flightDirection="IN" checkCurfew={tripData.withinCurfew} diverted={tripData.diverted} diversionDetails={tripData.diversionDetails}/>
          </div>
          <div className={classes.scrollArea}>
          {tripData.type === "EXTERNAL" ? <ExternalScreen tripData={tripData} classes={classes} eventBus={eventBus} colours={colours} indicators={tripLegIndicators?.data?.planningIndicators} canViewDetails={canViewDetails === true}/>:
          <>
            {selectedScreen==="map"?<MapScreen tripData={tripData} classes={classes} eventBus={eventBus} colours={colours} indicators={tripLegIndicators?.data?.planningIndicators} canViewDetails={canViewDetails === true}/>:null}
            {selectedScreen==="permits"?<PermitsScreen tripData={tripData} classes={classes} eventBus={eventBus} colours={colours} indicators={tripLegIndicators?.data?.planningIndicators}/>:null}
            {selectedScreen==="slots"?<SlotsScreen tripData={tripData} classes={classes} eventBus={eventBus} colours={colours} indicators={tripLegIndicators?.data?.planningIndicators}/>:null}
            {selectedScreen==="cargo"?<CargoScreen tripData={tripData} specialLoads={specialLoads?.data} classes={classes} eventBus={eventBus} colours={colours} indicators={tripLegIndicators?.data?.planningIndicators} canViewDetails={canViewDetails}/>:null}
            {/*{selectedScreen==="checklist"?<ChecklistScreen tripData={tripData} classes={classes} eventBus={eventBus} colours={colours} indicators={tripLegIndicators?.data?.planningIndicators} checklistSections={['FLIGHT DISPATCH','CLEAN FLIGHT']} icon="ChecklistIcon" heading="Flight Checklist" />:null}*/}
            {selectedScreen==="checklist"?<ChecklistScreen tripData={tripData} classes={classes} eventBus={eventBus} colours={colours} indicators={tripLegIndicators?.data?.planningIndicators} checklistSections={['CLEAN FLIGHT']} icon="ChecklistIcon" heading="Flight Checklist" />:null}
            {selectedScreen==="crew"?<CrewScreen tripData={tripData} classes={classes} eventBus={eventBus} colours={colours} indicators={tripLegIndicators?.data?.planningIndicators}/>:null}
            {selectedScreen==="services"?<ServicesScreen tripData={tripData} classes={classes} eventBus={eventBus} colours={colours} indicators={tripLegIndicators?.data?.planningIndicators} canViewDetails={canViewDetails}/>:null}
            {selectedScreen==="catering"?<CateringScreen tripData={tripData} classes={classes} eventBus={eventBus} colours={colours} indicators={tripLegIndicators?.data?.planningIndicators}/>:null}
            {selectedScreen==="fuel"?<FuelScreen tripData={tripData} classes={classes} eventBus={eventBus} colours={colours} indicators={tripLegIndicators?.data?.planningIndicators}/>:null}
            {selectedScreen==="notes"?<NotesScreen tripData={tripData} classes={classes} eventBus={eventBus} colours={colours} indicators={tripLegIndicators?.data?.planningIndicators} canViewDetails={canViewDetails}/>:null}
            {selectedScreen==="servicechecklist"?<ChecklistScreen tripData={tripData} classes={classes} eventBus={eventBus} colours={colours} indicators={tripLegIndicators?.data?.planningIndicators} checklistSections={['SERVICE REQUEST']} icon="playlist_add_check" heading="Service Checklist"/>:null}
            {selectedScreen==="monitor"?<MonitorScreen tripData={tripData} classes={classes} indicators={tripLegIndicators?.data?.planningIndicators}/>:null}
          </>}
        </div>
        <div style={{width: "calc(100% + 8px)", textAlign: "center", backgroundColor: "rgba(255,255,255,0.9)", marginLeft: -4, marginTop: 4, borderRadius: "0px 0px 3px 3px"}}>
          <div style={{width: "calc(100% - 16px)", marginLeft: 8, marginRight: 8}}>
            {tripData.type === "EXTERNAL" ? <></> : <TabBar callback={tabChanged} tripData={tripData} specialLoads={specialLoads?.data} editing={editing} selectedScreen={selectedScreen} indicators={tripLegIndicators?.data?.planningIndicators} canViewDetails={canViewDetails}/>}
          </div>
        </div>
      </div >
    )
  });

  const openToolTip = () => {
    if (!opened) {
      setOpened(true);
      toolTipPinned.current = {...toolTipPinned.current, uuid: tripData.uuid};
      if (!props.showAsSidePanel) eventBus.trigger("RouteView.popupPause", true);
    }
  }

  if (props.showAsSidePanel) {
    return (
      <TripScreen
        editing={editing}
        canChange={canChange}
        tripData={tripData}
        eventBus={eventBus}
        classes={classes}
        colours={colours}
        showAsSidePanel={props.showAsSidePanel}
      />
    )
  }
  return (
    <Tooltip open={opened} onOpen={openToolTip} onClose={handleClose} arrow interactive
      classes={{ popper: classes.tripTooltipPopper, tooltip: classes.tripTooltip }}
      placement="right"
      title={
        <TripScreen
          editing={editing}
          canChange={canChange}
          tripData={tripData}
          eventBus={eventBus}
          classes={classes}
          colours={colours}
          showAsSidePanel={props.showAsSidePanel}
        />
      }
      leaveDelay={300}
    >
      {props.children}
    </Tooltip>
  );
}

export default memo(TripTooltip);
